import { render, staticRenderFns } from "./ApprovalPetitionList.vue?vue&type=template&id=2b8c6a0c"
import script from "./ApprovalPetitionList.vue?vue&type=script&lang=js"
export * from "./ApprovalPetitionList.vue?vue&type=script&lang=js"
import style0 from "./ApprovalPetitionList.vue?vue&type=style&index=0&id=2b8c6a0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports